import React, { ReactNode } from 'react'

import styled from '@emotion/styled'

import { pills } from '@surglogs-app/images'

const StyledWrapperContainer = styled.div`
  height: 100vh;
  width: 100%;
  min-height: 100vh;
  padding: 10px;
  box-sizing: border-box;
  display: table;
  background-color: white;
`

const StyledContainer = styled.div`
  display: table-cell;
  vertical-align: middle;
  text-align: center;

  & h2 {
    margin-bottom: 5px;

    &:first-of-type {
      margin-bottom: 15px;
    }
  }
`

const ContentWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
  text-align: left;
`

const PillImage = styled.img`
  display: inline-block;
  vertical-align: middle;
  margin-right: 25px;
`

export interface ErrorScreenContentProps {
  children: ReactNode
}

export const ErrorScreenContent = ({ children }: ErrorScreenContentProps) => (
  <StyledWrapperContainer>
    <StyledContainer>
      <PillImage {...{ src: pills, alt: 'pills' }} />
      <ContentWrapper>{children}</ContentWrapper>
    </StyledContainer>
  </StyledWrapperContainer>
)
